import { getExperiment } from '@eventbrite/statsig';
import React, { createContext, ReactNode, useContext } from 'react';

interface StatsigProviderProps {
    children: ReactNode;
}

export const StatsigContext = createContext({
    organizerFollowExperiment: false,
});

export const StatsigProvider = ({ children }: StatsigProviderProps) => {
    const organizerFollowExperiment: boolean = getExperiment(
        'organizer_page_follow_tool_experiment',
        'show_follow_experiment',
        false,
    );
    return (
        <StatsigContext.Provider
            value={{
                organizerFollowExperiment: organizerFollowExperiment,
            }}
        >
            {children}
        </StatsigContext.Provider>
    );
};

export const useMyStatsigContext = () => {
    return useContext(StatsigContext);
};
